import { render, staticRenderFns } from "./Markdown.vue?vue&type=template&id=0032929d&scoped=true&"
import script from "./Markdown.vue?vue&type=script&lang=ts&"
export * from "./Markdown.vue?vue&type=script&lang=ts&"
import style0 from "./Markdown.vue?vue&type=style&index=0&id=0032929d&prod&scoped=true&lang=css&"
import style1 from "./Markdown.vue?vue&type=style&index=1&id=0032929d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0032929d",
  null
  
)

export default component.exports